/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Actions from './Actions/index'
import CloseAction from './CloseAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Referrals/Referral/Delete/Content"
  
}) {
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={0}
 level="h3"
 text="Delete Referral?"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={0}
 text="This will delete this referral permanantly. You cannot undo this action."
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}